/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Case } from './Case';
import {
    CaseFromJSON,
    CaseFromJSONTyped,
    CaseToJSON,
    CaseToJSONTyped,
} from './Case';

/**
 * 
 * @export
 * @interface CloseReason
 */
export interface CloseReason {
    /**
     * 
     * @type {string}
     * @memberof CloseReason
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof CloseReason
     */
    category?: CloseReasonCategoryEnum;
    /**
     * 
     * @type {string}
     * @memberof CloseReason
     */
    subCategory?: CloseReasonSubCategoryEnum;
    /**
     * 
     * @type {string}
     * @memberof CloseReason
     */
    description?: string;
    /**
     * 
     * @type {Case}
     * @memberof CloseReason
     */
    securityCase?: Case;
    /**
     * 
     * @type {string}
     * @memberof CloseReason
     */
    tenantId?: string;
    /**
     * 
     * @type {Date}
     * @memberof CloseReason
     */
    updated?: Date;
    /**
     * 
     * @type {Date}
     * @memberof CloseReason
     */
    created?: Date;
    /**
     * 
     * @type {string}
     * @memberof CloseReason
     */
    domain?: string;
}


/**
 * @export
 */
export const CloseReasonCategoryEnum = {
    ConfirmedThreat: 'confirmed_threat',
    LegitimateActivity: 'legitimate_activity',
    DetectionError: 'detection_error',
    AdministrativeClosure: 'administrative_closure',
    Inconclusive: 'inconclusive'
} as const;
export type CloseReasonCategoryEnum = typeof CloseReasonCategoryEnum[keyof typeof CloseReasonCategoryEnum];

/**
 * @export
 */
export const CloseReasonSubCategoryEnum = {
    RuleLogicError: 'rule_logic_error',
    DataQualityIssue: 'data_quality_issue',
    KnownSystemBehavior: 'known_system_behavior',
    Duplicate: 'duplicate',
    Superseded: 'superseded',
    Transferred: 'transferred'
} as const;
export type CloseReasonSubCategoryEnum = typeof CloseReasonSubCategoryEnum[keyof typeof CloseReasonSubCategoryEnum];


/**
 * Check if a given object implements the CloseReason interface.
 */
export function instanceOfCloseReason(value: object): value is CloseReason {
    return true;
}

export function CloseReasonFromJSON(json: any): CloseReason {
    return CloseReasonFromJSONTyped(json, false);
}

export function CloseReasonFromJSONTyped(json: any, ignoreDiscriminator: boolean): CloseReason {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'category': json['category'] == null ? undefined : json['category'],
        'subCategory': json['subCategory'] == null ? undefined : json['subCategory'],
        'description': json['description'] == null ? undefined : json['description'],
        'securityCase': json['securityCase'] == null ? undefined : CaseFromJSON(json['securityCase']),
        'tenantId': json['tenantId'] == null ? undefined : json['tenantId'],
        'updated': json['updated'] == null ? undefined : (new Date(json['updated'])),
        'created': json['created'] == null ? undefined : (new Date(json['created'])),
        'domain': json['domain'] == null ? undefined : json['domain'],
    };
}

export function CloseReasonToJSON(json: any): CloseReason {
    return CloseReasonToJSONTyped(json, false);
}

export function CloseReasonToJSONTyped(value?: CloseReason | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'category': value['category'],
        'subCategory': value['subCategory'],
        'description': value['description'],
        'securityCase': CaseToJSON(value['securityCase']),
        'tenantId': value['tenantId'],
        'updated': value['updated'] == null ? undefined : ((value['updated']).toISOString()),
        'created': value['created'] == null ? undefined : ((value['created']).toISOString()),
        'domain': value['domain'],
    };
}

